import { Drawer } from "@mantine/core";

import NavbarList from "@/components/Navbar/NavbarList";
import { useWhitelabelBrand } from "@/hooks/useWhitelabelBrand";

interface NavbarDrawerProps {
  opened: boolean;
  onClose: () => void;
}

const NavbarDrawer = ({ opened = false, onClose }: NavbarDrawerProps) => {
  const { whitelabelBrand } = useWhitelabelBrand();
  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      size="xl"
      offset={8}
      radius="md"
      overlayProps={{ backgroundOpacity: 0.5, blur: 4 }}
      transitionProps={{
        transition: "slide-left",
      }}
      title={whitelabelBrand.name}
    >
      <NavbarList onClose={onClose} />
    </Drawer>
  );
};

export default NavbarDrawer;
